/**
 * lugarDelActa — qué zona de la plantilla es el lugar de la reunión.
 *
 * Se reconoce por la etiqueta, como el folio y las fechas, porque las zonas se
 * deducen del .docx de cada organización y no hay un identificador estable que
 * marcar.
 *
 * La lista es deliberadamente corta. «Lugar», «Sede», «Sala», «Ubicación». No
 * entra «Dirección» —que en un acta suele ser la junta directiva y no una calle—
 * ni «Área», que casi siempre es el departamento de quien convoca.
 */

const sinTildes = (t) => String(t || '')
  .toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export function esEtiquetaDeLugar(etiqueta) {
  const texto = sinTildes(etiqueta).trim();
  if (!texto) return false;
  return /(^|\s)(lugar|sede|sala|ubicacion|sitio|recinto|aula)(\s|$|:)/.test(texto);
}

/** La zona del lugar, si la plantilla tiene una. */
export function zonaDeLugar(regiones) {
  if (!Array.isArray(regiones)) return null;
  return regiones.find(r => r && r.tipo === 'valor' && esEtiquetaDeLugar(r.etiqueta)) || null;
}
